/* TealerLab Cart Drawer — JS controller (config injected via window.tlrCartConfig) */
(function () {
  const TLR_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  window._tlrCartIIFEStarted = true;

  const CFG = window.tlrCartConfig || {};
  const SAMPLE_THRESHOLD = (CFG.ship?.sample?.cents) || 100;  // palier échantillon (défaut 1€)
  // Replis alignés sur les défauts du schéma (49/69/79/99 €) et sur la page panier :
  // ils ne servent que si la section n'a pas émis la config.
  const SHIP_THRESHOLD = (CFG.ship?.t1?.cents) || 4900;       // palier 1
  const REWARD_T2      = (CFG.ship?.t2?.cents) || 6900;       // palier 2
  const REWARD_T3      = (CFG.ship?.t3?.cents) || 7900;       // palier 3
  const REWARD_T4      = (CFG.ship?.t4?.cents) || 9900;       // palier 4
  const TS_LABEL       = (CFG.ship?.sample?.label) || 'Échantillon offert';
  const T1_LABEL       = (CFG.ship?.t1?.label) || 'Livraison offerte';
  const T2_LABEL       = (CFG.ship?.t2?.label) || 'Sticker offert';
  const T3_LABEL       = (CFG.ship?.t3?.label) || 'Grinder offert';
  const T4_LABEL       = (CFG.ship?.t4?.label) || '+10g offerts';
  // Chaînes traduites injectées par la section (locales tlr.cart.*) — jamais de texte en dur ici.
  const I18N           = CFG.i18n || {};
  const LOYALTY_POINTS_PER_EURO  = CFG.loyalty?.ptsPerEuro ?? 1;
  const LOYALTY_REWARD_PER_POINT = (CFG.loyalty?.rewardPer100Pts ?? 2) / 100; // €/pt
  // Filtre les empty strings (peuvent venir d'un Liquid split sur string vide)
  const _cleanHandles = (arr) => (arr || []).filter(h => h && typeof h === 'string' && h.trim().length > 0);
  const SAMPLE_HANDLES = _cleanHandles(CFG.samples?.handles).length
    ? _cleanHandles(CFG.samples.handles)
    : ['mojo-mango-kush', 'green-crack', 'gelato-cake', 'purple-haze', 'hulk-hash'];
  const UPSELL_HANDLES  = _cleanHandles(CFG.upsell?.handles);
  const UPSELL_LIMIT    = Number.isInteger(CFG.upsell?.limit) && CFG.upsell.limit > 0 ? CFG.upsell.limit : 4;
  const GIFT_HANDLES    = _cleanHandles(CFG.gifts?.handles);
  // Variant titles configurés par l'admin pour chaque slot gift (ex: ["10g","3.5g"]).
  // L'array peut contenir des strings vides — fallback à variants[0] dans ce cas.
  const GIFT_VARIANT_TITLES = (CFG.gifts?.variantTitles || []).map(t => (t || '').trim());
  // Codes promo SupaEasy à appliquer auto pour rendre samples/gifts gratuits (100% off tag-based)
  const SAMPLE_CODE     = (CFG.gifts?.sampleCode || '').trim();
  const GIFT_CODE       = (CFG.gifts?.giftCode || '').trim();
  // Le module ne montre plus d'emoji : l'état verrouillé est porté par l'icône SVG de l'entête,
  // donc on retire ceux que le message du customizer pourrait contenir.
  const GIFT_LOCKED_MSG = String(CFG.gifts?.lockedMsg || '{delta}')
    .replace(/\p{Extended_Pictographic}\uFE0F?/gu, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
  // 0 is a legitimate value (no minimum): only a missing one falls back to 10 €.
  const MIN_ORDER       = Number.isFinite(CFG.minOrder?.cents) ? CFG.minOrder.cents : 1000; // centimes
  /**
   * Liste ordonnée des paliers réellement affichés. Un palier décoché dans le customizer
   * (`on: false`) ou sans montant sort de la liste comme s'il n'existait pas ; `on` absent
   * vaut actif (config émise avant l'ajout des cases). `cents` du config prime, y compris
   * 0 — le repli codé ne sert que quand la clé manque.
   */
  function shipTiers(ship, tiers) {
    const out = [];
    for (const t of tiers) {
      const cfg = (ship && ship[t.cfg]) || {};
      const cents = Number.isFinite(cfg.cents) ? cfg.cents : t.cents;
      if (cfg.on === false || !(cents > 0)) continue;
      // `type` et `rewards` viennent du palier lui-même (réglages par palier) : une config
      // émise avant leur ajout n'en a pas, ce qui vaut « Automatique, aucun produit ».
      out.push({ ...t, cents, type: cfg.type || 'auto', rewards: Array.isArray(cfg.rewards) ? cfg.rewards : [] });
    }
    return out;
  }

  /**
   * Ce que les paliers débloquent, et à partir de quel montant.
   *
   * Le type est choisi palier par palier dans le customizer. `auto` est le défaut du schéma,
   * donc l'état de toutes les boutiques tant que personne n'y touche : il rejoue le modèle
   * précédent — le palier échantillon ouvre le sélecteur d'échantillons, le palier nommé par
   * « Palier qui débloque le cadeau » ouvre les cadeaux, les autres n'ouvrent rien. Dès qu'UN
   * palier affiché porte un autre type, le modèle par palier prend le relais : seuils lus sur
   * les paliers, un cadeau de plus par palier « cadeau » atteint, et les produits des paliers
   * (les anciens sélecteurs ne servent plus que de repli quand un palier n'en nomme aucun).
   *
   * Montants : un palier à 0 n'existe pas (shipTiers l'a déjà retiré). Dans la branche du
   * modèle précédent, 0 ou absent veut dire « jamais réglé » et garde le montant codé —
   * c'est le comportement actuel des boutiques, le changer déplacerait leurs récompenses.
   *
   * Produits : le catalogue dépend du total. Un palier non atteint n'offre rien, donc les
   * listes se lisent par `sampleRewardsAt(total)` / `giftRewardsAt(total)` à chaque rendu —
   * une liste figée laisserait choisir le cadeau du dernier palier dès le premier.
   */
  function rewardPlan(tiers, legacy) {
    // Another currency without round amounts: no sample, gift or coded fallback threshold.
    if (legacy.off) return { typed: true, blockCents: null, sampleCents: null, giftCents: null, sampleRewardsAt: () => [], giftRewardsAt: () => [], maxGifts: () => 0 };
    const TYPES = ['shipping', 'sample', 'gift'];
    if (!tiers.some((t) => TYPES.indexOf(t.type) >= 0)) {
      const amount = (v, coded) => (Number.isFinite(v) && v > 0 ? v : coded);
      const sampleCents = amount(legacy.sampleCents, 100);
      const giftCents = amount(legacy.giftCents, 5900);
      const twoGiftsCents = amount(legacy.twoGiftsCents, 9900);
      return {
        typed: false,
        blockCents: sampleCents,
        sampleCents,
        giftCents,
        sampleRewardsAt: () => [],
        giftRewardsAt: () => [],
        maxGifts: (total) => (total >= twoGiftsCents ? 2 : total >= giftCents ? 1 : 0),
      };
    }
    const pick = (type) => tiers.filter((t) => t.type === type);
    // Offert à ce total : un palier non atteint ne donne rien, et deux paliers qui offrent la
    // même variante ne font qu'un bouton (deux jumeaux se désélectionneraient l'un l'autre).
    const rewardsOf = (list, total) => {
      const seen = [];
      return list
        .reduce((all, t) => (total >= t.cents ? all.concat(t.rewards || []) : all), [])
        .filter((r) => {
          if (!r || !r.id || seen.indexOf(String(r.id)) >= 0) return false;
          seen.push(String(r.id));
          return true;
        });
    };
    const sampleTiers = pick('sample');
    const giftTiers = pick('gift');
    const giftSteps = giftTiers.map((t) => t.cents).sort((a, b) => a - b);
    const sampleCents = sampleTiers.length ? Math.min(...sampleTiers.map((t) => t.cents)) : null;
    const giftCents = giftSteps.length ? giftSteps[0] : null;
    const unlocks = [sampleCents, giftCents].filter((c) => c !== null);
    return {
      typed: true,
      blockCents: unlocks.length ? Math.min(...unlocks) : null,
      sampleCents,
      giftCents,
      sampleRewardsAt: (total) => rewardsOf(sampleTiers, total),
      giftRewardsAt: (total) => rewardsOf(giftTiers, total),
      // Un cadeau de plus par palier atteint, jamais plus que de produits distincts à
      // choisir : promettre deux cadeaux devant un seul bouton bloque le client.
      maxGifts: (total) => {
        const reached = giftSteps.filter((c) => total >= c).length;
        const offered = rewardsOf(giftTiers, total).length;
        return offered > 0 ? Math.min(reached, offered) : reached;
      },
    };
  }

  // Paliers dans l'ordre croissant du barème — la clé sert d'icône (#tlr-icn-<key>) et
  // d'ancre DOM : la section rend une colonne par palier actif, avec la même règle.
  const TIERS = shipTiers(CFG.ship, [
    { key: 'ts', cfg: 'sample', cents: SAMPLE_THRESHOLD, label: TS_LABEL },
    { key: 't1', cfg: 't1',     cents: SHIP_THRESHOLD,   label: T1_LABEL },
    { key: 't2', cfg: 't2',     cents: REWARD_T2,        label: T2_LABEL },
    { key: 't3', cfg: 't3',     cents: REWARD_T3,        label: T3_LABEL },
    { key: 't4', cfg: 't4',     cents: REWARD_T4,        label: T4_LABEL },
  ]);

  const PLAN = rewardPlan(TIERS, {
    off: CFG.marketOff === true,
    sampleCents: CFG.ship?.sample?.cents,
    giftCents: CFG.gifts?.threshold,
    twoGiftsCents: CFG.ship?.t4?.cents,
  });

  // Modèle des cadeaux par palier (assets/tlr-gift-tiers.js, chargé avant ce script).
  const GIFTS = window.TlrGiftTiers || null;
  // État d'INTERFACE seulement : quel palier le client est en train de changer, et le
  // message à lui montrer quand un cadeau a été retiré. L'état du panier, lui, ne vit
  // que dans le panier.
  let editingTier = null;
  let giftNotice = '';
  const GIFT_CTX = {
    escapeHtml: escapeHTML,
    fmtMoney: (cents) => fmtMoney(cents),
    shortName: (t) => shortRewardName(t),
    i18n: {
      giftsTierPick: I18N.giftsTierPick,
      giftsTierLocked: I18N.giftsTierLocked || GIFT_LOCKED_MSG,
      giftsClaimedTitle: I18N.giftsClaimedTitle,
      giftsChange: I18N.giftsChange,
      giftsAllClaimed: I18N.giftsAllClaimed,
      giftsPickOne: I18N.giftsPickOne,
    },
  };

  // Paliers effectifs : ceux du customizer, plus le repli « ancien modèle » que le module
  // construit au besoin. Les deux écrans partagent la même liste.
  const LEGACY_GIFTS = { cents: PLAN.giftCents, handles: GIFT_HANDLES, variantTitles: GIFT_VARIANT_TITLES };
  const currentTiers = () => (GIFTS ? GIFTS.tiersOf(TIERS) : TIERS);

  // Regroupement d'affichage du pack composé (assets/tlr-cart-pack.js).
  const PACK = window.TlrCartPack || null;
  const PACK_CTX = {
    escapeHtml: escapeHTML,
    fmtMoney: (cents) => fmtMoney(cents),
    editUrl: (CFG.pack && CFG.pack.url) || '',
    i18n: {
      // Un titre par origine : le pack composé et le pack de la page d'accueil se rendent
      // pareil, mais ne s'appellent pas pareil.
      titles: { 'pack-builder': I18N.packTitle, bundle: I18N.bundleTitle },
      packTitle: I18N.packTitle,
      packItems: I18N.packItems,
      packShow: I18N.packShow,
      packHide: I18N.packHide,
      packEdit: I18N.packEdit,
      remove: I18N.itemRemove,
    },
  };

  let cartCache = null;
  let _bodyScrollY = 0; // sauvegarde position scroll pour iOS lock
  const compareCache = {}; // handle → { variantId: compareAtPriceCents }
  let _upsellKey = null;          // clé de cache pour éviter re-fetch des produits upsell
  let _refreshDebounceTimer = null; // debounce des cart:updated externes

  /** Charge les compare_at_price depuis /products/{handle}.js (manquant dans cart.js). */
  async function loadComparePrices(items) {
    const handles = [...new Set((items || []).map(i => i.handle).filter(h => h && !(h in compareCache)))];
    if (!handles.length) return;
    await Promise.all(handles.map(async (handle) => {
      try {
        const r = await fetch(`${TLR_ROOT}products/${handle}.js`, { cache: 'force-cache' });
        const p = await r.json();
        compareCache[handle] = {};
        (p.variants || []).forEach(v => { compareCache[handle][v.id] = v.compare_at_price || 0; });
      } catch (_) { compareCache[handle] = {}; }
    }));
  }

  const dlg = document.getElementById('tlr-cart-drawer');
  window._tlrCartDlgFound = !!dlg;
  if (!dlg) return;
  window._tlrCartIIFECompleted = true;

  const $ = (sel) => dlg.querySelector(sel);
  const $$ = (sel) => dlg.querySelectorAll(sel);

  function fmtMoney(cents) {
    try {
      return new Intl.NumberFormat(window.tlr?.locale || 'fr-FR', { style: 'currency', currency: window.tlr?.currency || 'EUR' }).format((cents || 0) / 100);
    } catch (_) { return ((cents || 0) / 100).toFixed(2) + ' ' + (window.tlr?.currency || 'EUR'); }
  }

  // « Plus que <strong>12,50 €</strong> » — le gabarit vient des locales, le montant est
  // injecté via un remplaçant fonction pour neutraliser les motifs $& de String.replace.
  function remainingText(cents) {
    const amount = `<strong>${escapeHTML(fmtMoney(cents))}</strong>`;
    return (I18N.shipRemaining || '{amount}').replace('{amount}', () => amount);
  }

  // `| t` échappe toutes les clés sauf les *_html et `| json` conserve l'entité : une chaîne
  // traduite posée en textContent doit être décodée avant.
  const ENTITIES = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'" };
  const decodeEntities = (s) => String(s).replace(/&(amp|lt|gt|quot|#39);/g, (m) => ENTITIES[m]);
  // Locale strings arrive HTML-escaped by `| t`: decode once, escape again where they meet markup.
  const L = (k) => decodeEntities(I18N[k] || '');

  /** Nom court affiché sur un bouton récompense (le préfixe interne « TLR Cart » ne sort pas). */
  function shortRewardName(title) {
    return String(title || '').replace(/^TLR Cart\s*/i, '').trim().split(' ').slice(0, 3).join(' ');
  }

  /**
   * Boutons d'une colonne récompense à partir des produits déjà résolus par la section
   * (id de variante, titre, grammage, image) : aucun aller-retour /products/<handle>.js.
   */
  function rewardButtonsHtml(rewards, type) {
    const idAttr = type === 'gift' ? 'data-gift-variant' : 'data-sample-variant';
    const handleAttr = type === 'gift' ? 'data-gift-handle' : 'data-sample-handle';
    return (rewards || []).map((r) => {
      const variantTitle = String(r.variantTitle || '');
      return `
        <button type="button" class="tlr-cart__sample-btn${variantTitle ? ' tlr-cart__sample-btn--variant' : ''}" ${idAttr}="${escapeHTML(String(r.id))}" ${handleAttr}="${escapeHTML(r.handle || '')}">
          ${r.image ? `<img src="${escapeHTML(r.image)}" alt="${escapeHTML(r.title || '')}" loading="lazy">` : ''}
          <span class="tlr-cart__sample-name">${escapeHTML(shortRewardName(r.title))}</span>
          ${variantTitle ? `<span class="tlr-cart__sample-variant">${escapeHTML(variantTitle)}</span>` : ''}
        </button>`;
    }).join('');
  }

  /**
   * Marque une grille récompense à reconstruire quand le catalogue offert change : le
   * contenu dépend du total (un palier franchi ajoute des produits), le drapeau « déjà
   * chargé » figerait sinon la grille sur le premier rendu du panier.
   */
  function rearmRewardGrid(grid, rewards) {
    const key = rewards.map((r) => r.id).join(',');
    if (grid.dataset.rewardKey === key) return;
    grid.dataset.rewardKey = key;
    grid.dataset.loaded = '';
  }

  // Échappe le HTML pour empêcher tout injection XSS via title/properties/codes
  // (cf. audit V1 — docs/audit/CHANGES-SECURITY.md).
  function escapeHTML(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // overflow:hidden sur html + body — iOS 15.4+ le supporte sans position:fixed.
  // Pas de position:fixed → pas de scroll-to-top à la fermeture.
  function lockBodyScroll() {
    document.documentElement.classList.add('tlr-scroll-locked');
    document.body.classList.add('tlr-scroll-locked');
  }
  function unlockBodyScroll() {
    document.documentElement.classList.remove('tlr-scroll-locked');
    document.body.classList.remove('tlr-scroll-locked');
  }

  // La feuille du drawer arrive en print-trick (non bloquante) : une ouverture
  // qui gagne la course affiche le dialog brut. On force la bascule et on
  // attend la feuille — au pire 1,5 s de garde, en pratique ~0 (preload).
  function ensureDrawerCss(done) {
    const link = document.querySelector('link[rel="stylesheet"][href*="tlr-cart-drawer"]');
    if (!link || (link.media === 'all' && link.sheet)) { done(); return; }
    let fired = false;
    const go = () => { if (!fired) { fired = true; done(); } };
    link.addEventListener('load', go, { once: true });
    setTimeout(go, 1500);
    link.media = 'all';
  }

  window.tlrOpenCart = function () {
    // Ferme tout dialog natif Horizon ouvert
    document.querySelectorAll('dialog.cart-drawer__dialog[open], cart-drawer-component dialog[open]').forEach(d => {
      if (d.id !== 'tlr-cart-drawer') {
        try { d.close(); } catch (_) {}
      }
    });
    refreshCart();
    ensureDrawerCss(() => {
      if (!dlg.open) {
        try { dlg.showModal(); } catch (_) { dlg.setAttribute('open', ''); }
      }
      lockBodyScroll();
      document.body.classList.add('tlr-cart-open');
    });
    return true;
  };
  window.tlrCloseCart = function () {
    if (!dlg.open) return;
    if (dlg.classList.contains('is-closing')) return; // déjà en fermeture
    dlg.classList.add('is-closing');
    setTimeout(() => {
      dlg.classList.remove('is-closing');
      try { dlg.close(); } catch (_) { dlg.removeAttribute('open'); }
      unlockBodyScroll();
      document.body.classList.remove('tlr-cart-open');
    }, 320);
  };
  // Listen for native dialog close (ESC, backdrop click, etc.)
  dlg.addEventListener('close', function () {
    unlockBodyScroll();
    document.body.classList.remove('tlr-cart-open');
  });

  // Block tout open du dialog natif Horizon (interception MutationObserver)
  function blockNativeDialog() {
    const nativeDialogs = document.querySelectorAll('dialog.cart-drawer__dialog, cart-drawer-component dialog');
    nativeDialogs.forEach(d => {
      if (d.id === 'tlr-cart-drawer') return;
      // Override showModal pour rediriger vers notre drawer
      if (!d._tlrPatched) {
        d._tlrPatched = true;
        const origShowModal = d.showModal.bind(d);
        const origShow = d.show ? d.show.bind(d) : null;
        d.showModal = function () { window.tlrOpenCart(); };
        if (origShow) d.show = function () { window.tlrOpenCart(); };
        // Si déjà ouvert : ferme-le et ouvre le nôtre
        if (d.hasAttribute('open')) {
          try { d.close(); } catch (_) {}
          window.tlrOpenCart();
        }
        // Observer pour détecter les open futurs
        new MutationObserver((muts) => {
          muts.forEach(m => {
            if (m.attributeName === 'open' && d.hasAttribute('open')) {
              try { d.close(); } catch (_) {}
              window.tlrOpenCart();
            }
          });
        }).observe(d, { attributes: true });
      }
    });
  }
  blockNativeDialog();
  // Re-bind si le DOM change (Horizon peut ré-injecter)
  new MutationObserver(blockNativeDialog).observe(document.body, { childList: true, subtree: true });

  $('[data-tlr-cart-close]')?.addEventListener('click', window.tlrCloseCart);

  // Declencheurs d'ouverture poses dans le markup (ex. le bouton panier de header-actions).
  // Delegation sur le document : survit aux re-rendus de section par le customizer.
  // Le markup est un <a href="/cart"> : si ce script ne charge pas, le clic degrade vers la
  // page panier au lieu de ne rien faire.
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-tlr-cart-open]');
    if (!trigger) return;
    e.preventDefault();
    if (!(window.tlrOpenCart && window.tlrOpenCart())) window.location.href = TLR_ROOT + 'cart';
  });
  // Close on backdrop click — uniquement si le target EST le dialog lui-même (pas un enfant)
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg) {
      window.tlrCloseCart();
    }
  });

  // précédentes qui ne contribuent plus mais squattent les slots de classe
  // Shopify (1 code par classe order/product/shipping max au checkout).
  //
  // Sans ça, un TLRPACK15 zombie (product class, du précédent test) bloque le
  // slot product → un nouveau code product (genre TRLRUNOVR -100% pochon) est
  // rejeté par Shopify silencieusement.
  //
  // Mécanique : clear total + re-apply uniquement les codes applicables.
  // Retourne le cart nettoyé, ou null si rien à nettoyer.
  async function stripZombieCodes(cart) {
    const existing = (cart?.discount_codes || []).filter(
      (d) => d && typeof d.code === 'string' && d.code.length > 0,
    );
    const isTealerRun = (code) => /^(TRLRUN|TEALERRUN)/i.test(code || '');
    // Détection orphans : si TRLRUNOVR-* code actif MAIS aucun pochon Tealer Run
    // dans le cart → user a retiré le freebie → les codes Tealer Run (qui étaient
    // liés au gain Overdrive) deviennent contextuellement orphelins → strip.
    const hasOvrCode = existing.some((d) => /^TRLRUNOVR/i.test(d.code));
    const hasOverdriveItem = (cart?.items || []).some(
      (it) => it?.properties?._tlr_game_freebie === 'overdrive',
    );
    const orphanTealerRun = hasOvrCode && !hasOverdriveItem;

    // Zombies = codes non-applicable ET non-Tealer Run.
    // Les codes Tealer Run sont préservés même si applicable:false : ils peuvent
    // devenir applicable plus tard quand l'user ajoute des items payants
    // (ex: cart=pochon seul → TRLRUN10 -10% inapplicable car 0€ à discount,
    // mais reste posé pour s'activer dès le 1er produit payant ajouté).
    const hasZombies = existing.some((d) => !d.applicable && !isTealerRun(d.code));
    if (!hasZombies && !orphanTealerRun) return null;
    try {
      await fetch(TLR_ROOT + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' }),
      });
      // Re-applique :
      //  - tous les codes applicables non-orphelins
      //  - + tous les Tealer Run non-orphelins (même si inapplicables, réserve)
      const keep = existing
        .filter((d) => {
          if (orphanTealerRun && isTealerRun(d.code)) return false;
          return d.applicable || isTealerRun(d.code);
        })
        .map((d) => d.code);
      await Promise.all(keep.map(c =>
        fetch(`/discount/${encodeURIComponent(c)}`, { redirect: 'follow', credentials: 'same-origin' })
      ));
      const r = await fetch(TLR_ROOT + 'cart.js', { cache: 'no-store' });
      return await r.json();
    } catch (_) {
      return null;
    }
  }

  async function refreshCart() {
    try {
      const r = await fetch(TLR_ROOT + 'cart.js', { cache: 'no-store' });
      cartCache = await r.json();
      // Auto-nettoie les codes zombies (applicable:false) à chaque refresh
      const cleaned = await stripZombieCodes(cartCache);
      if (cleaned) cartCache = cleaned;
      // Total RÉEL des items payants — une seule règle, celle de computeRealPaidTotal().
      const realPaidTotal = computeRealPaidTotal();
      // Échantillon : il ne survit pas sous le palier qui l'a débloqué — la colonne est
      // masquée en dessous, le client ne pourrait plus le retirer lui-même.
      const sampleLine = (cartCache.items || []).find(it => {
        const p = it.properties || {};
        return p._is_sample === 'true' || p._is_sample === true;
      });
      if (sampleLine && (PLAN.sampleCents === null || realPaidTotal < PLAN.sampleCents)) {
        try { await cartRemoveByKey(sampleLine.key); } catch (_) {}
      }
      // Cadeaux : un par palier, identifié par `_tlr_tier` sur la ligne. On ne retire donc
      // plus « le plus ancien » quand le panier baisse, mais exactement le cadeau du palier
      // perdu — et on l'annonce, sinon un cadeau disparaît sans explication.
      if (GIFTS) {
        // Le message ne vaut que pour le retrait qui vient d'avoir lieu : sans cette remise à
        // zéro, « cadeau retiré » restait affiché sur un panier qui avait entre-temps regrimpé.
        giftNotice = '';
        const tiers = await GIFTS.ensureTiers(TIERS, LEGACY_GIFTS);
        const giftState = GIFTS.computeState(tiers, cartCache.items || [], realPaidTotal);
        for (const stale of giftState.stale) {
          try { await cartRemoveByKey(stale.line.key); } catch (_) {}
          if (stale.tier) {
            giftNotice = GIFTS.fill(I18N.giftRemoved || '', 'amount', fmtMoney(stale.tier.cents));
          }
        }
      }
      // Note : les gifts EasyGift (_Gifted) sont gérés par EG via son option
      // "Remove added products when trigger conditions are no longer met"
      await loadComparePrices(cartCache.items || []);
      render();
    } catch (_) {}
  }

  function render() {
    if (!cartCache) return;
    window.tlr?.events?.syncCart?.(cartCache);
    renderShipping();
    renderItems();
    bindItemsDelegation(); // bind 1× après le 1er render
    renderTotal();
    renderLoyalty();
    renderSamples();
    renderUpsell();
    $('[data-tlr-cart-count]').textContent = cartCache.item_count || 0;
  }

  // Total RÉEL des items payants (exclut samples/gifts/EasyGift _Gifted)
  // Utilisé pour évaluer les paliers (ship bar, max gifts, samples block)
  // — pas affecté par cart-level discounts (codes promo) pour éviter le cercle vicieux
  function computeRealPaidTotal() {
    if (!cartCache) return 0;
    return (cartCache.items || []).reduce((acc, it) => {
      const p = it.properties || {};
      const isOurFreebie = p._is_gift === 'true' || p._is_gift === true || p._is_sample === 'true' || p._is_sample === true;
      const isEgGift = !!p._Gifted;
      if (isOurFreebie || isEgGift) return acc;
      return acc + (it.final_line_price || 0) + giftAllocationOn(it);
    }, 0);
  }

  /**
   * Remise « offert » tombée sur une ligne PAYANTE.
   *
   * La function de remise cible une VARIANTE, pas une ligne : quand le cadeau porte le même
   * variant qu'un article déjà au panier, Shopify scinde la ligne payante et y applique le
   * -100 % (constaté le 2026-09-21 : 6 × M&M'HAZE 3 g + le même en cadeau → l'unité offerte
   * est prise sur la ligne payante). Le client paie bien une unité de moins, mais ce n'est
   * pas une baisse du panier payant : sans ce rattrapage, le palier s'effondre et le cadeau
   * qu'on vient de choisir est retiré dans la foulée.
   */
  function giftAllocationOn(item) {
    const label = String(I18N.giftFree || '').trim().toLowerCase();
    if (!label) return 0;
    return (item.line_level_discount_allocations || []).reduce((sum, a) => {
      const title = String(a?.discount_application?.title || '').trim().toLowerCase();
      return sum + (title === label ? (a.amount || 0) : 0);
    }, 0);
  }

  function renderShipping() {
    const ship = $('[data-tlr-cart-ship]');
    if (!ship || !TIERS.length) return;
    const total = computeRealPaidTotal();

    // Index du prochain palier non atteint dans la liste ACTIVE — -1 quand tout est débloqué.
    const nextIdx = TIERS.findIndex((tier) => total < tier.cents);

    // Le message ne montre QUE le prochain gain : montant restant en tête, libellé du palier
    // dessous. Un seul objectif à la fois.
    let headline;
    let goal;
    let iconKey;
    if (nextIdx < 0) {
      headline = I18N.shipAllUnlocked || '';
      goal = I18N.shipAllUnlockedGoal || '';
      iconKey = 'done';
    } else if (total <= 0) {
      headline = I18N.shipStart || '';
      goal = TIERS[0].label;
      iconKey = TIERS[0].key;
    } else {
      headline = remainingText(TIERS[nextIdx].cents - total);
      goal = TIERS[nextIdx].label;
      iconKey = TIERS[nextIdx].key;
    }
    $('[data-tlr-ship-msg]').innerHTML =
      `<span class="tlr-cart__ship-remaining">${headline}</span>` +
      `<span class="tlr-cart__ship-goal">${escapeHTML(goal)}</span>`;
    ship.dataset.state = nextIdx < 0 ? 'done' : 'progress';
    // Le badge porte un noeud par palier actif (+ « done ») : chaque palier choisit son
    // icône du thème, son emoji ou son image, et seule celle du palier visé s'affiche.
    const badge = $('[data-tlr-ship-badge]');
    if (badge) badge.dataset.icon = iconKey;

    renderShipSteps(total);
  }

  /**
   * Une mini-barre par palier, côte à côte : chacune se remplit indépendamment
   * (total payé / seuil du palier), atteint = coche sur l'icône + pill pleine.
   * Les libellés sont raccourcis pour tenir dans une colonne de ~64 px à 390.
   * Chaque colonne est retrouvée par sa clé de palier : un palier décoché n'est
   * rendu par la section ni ici, sans décaler les autres.
   */
  function renderShipSteps(total) {
    $$('[data-tlr-step]').forEach((step) => {
      const i = TIERS.findIndex((t) => t.key === step.dataset.tlrStep);
      const tier = TIERS[i];
      if (!tier) return;
      step.dataset.state = total >= tier.cents ? 'done' : 'todo';
      const fill = step.querySelector('[data-tlr-step-fill]');
      if (fill) {
        // Remplissage séquentiel : chaque barre couvre [palier précédent → son
        // palier]. Une seule barre partielle à la fois — les précédentes sont
        // pleines, les suivantes vides.
        const from = i > 0 ? TIERS[i - 1].cents : 0;
        const span = tier.cents - from;
        fill.style.width = (span > 0
          ? clampPct(((total - from) / span) * 100)
          : (total >= tier.cents ? 100 : 0)) + '%';
      }
      const pill = step.querySelector('[data-tlr-step-pill]');
      if (pill && pill.dataset.short !== 'true') {
        pill.dataset.short = 'true';
        pill.textContent = shortRewardLabel(tier.label);
      }
    });
  }

  /**
   * Libellé de pill : on retire le suffixe redondant du barème (« offert », « free »… —
   * la liste vient des locales) pour tenir dans la colonne. Le libellé complet reste
   * porté par l'aria-label et le title posés par la section.
   */
  function shortRewardLabel(label) {
    let out = String(label || '').trim();
    (I18N.rewardSuffixStrip || '').split(',').forEach((word) => {
      const w = word.trim();
      if (!w) return;
      const re = new RegExp('\\s+' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', 'i');
      out = out.replace(re, '');
    });
    return out.trim() || String(label || '');
  }

  function clampPct(v) {
    return Math.min(100, Math.max(0, v));
  }

  function renderItems() {
    const wrap = $('[data-tlr-cart-items]');
    if (!cartCache.items || cartCache.items.length === 0) {
      wrap.innerHTML = `
        <div class="tlr-cart__empty">
          <span class="tlr-cart__empty-emoji">${escapeHTML(L('emptyEmoji'))}</span>
          <h3>${escapeHTML(L('emptyTitle'))}</h3>
          <p>${escapeHTML(L('emptyText'))}</p>
          <a href="${escapeHTML(L('emptyUrl') || TLR_ROOT + 'collections/all')}" class="tlr-cart__empty-cta">${escapeHTML(L('emptyCta'))}</a>
        </div>`;
      $('[data-tlr-cart-checkout]').setAttribute('disabled', '');
      const minEl = $('[data-tlr-cart-min-order]');
      if (minEl) minEl.hidden = true;
      return;
    }
    // Vérification montant minimum commande
    const _cartTotal  = cartCache.total_price || 0;
    const _minEl      = $('[data-tlr-cart-min-order]');
    const _checkoutBtn = $('[data-tlr-cart-checkout]');
    // On exclut les freebies du total pour le calcul (cadeau/échantillon à 0€ ne comptent pas)
    const _realTotal = (cartCache.items || []).reduce((acc, it) => {
      const p = it.properties || {};
      const isFreebie = p._is_gift === 'true' || p._is_gift === true || p._is_sample === 'true' || p._is_sample === true;
      return acc + (isFreebie ? 0 : (it.final_line_price || 0));
    }, 0);
    if (_realTotal < MIN_ORDER) {
      _checkoutBtn.setAttribute('disabled', '');
      if (_minEl) {
        const delta = fmtMoney(MIN_ORDER - _realTotal);
        _minEl.textContent = L('minOrder').replace('{delta}', delta);
        _minEl.hidden = false;
      }
    } else {
      _checkoutBtn.removeAttribute('disabled');
      if (_minEl) _minEl.hidden = true;
    }
    // Si Shopify a déjà appliqué le code discount (cookie /discount/CODE posé), on lit les vrais champs
    // cart.js. Sinon on fait un preview visuel local. Évite le double-discount.
    const shopifyDiscountActive = (cartCache.total_discount || 0) > 0;
    const subDiscountPctItems = parseInt(window.tlr?.ovri?.discount_pct, 10) || 15;
    // On utilise l'INDEX 1-based (line) au lieu du key — plus fiable avec /cart/change.js
    // Les lignes du pack composé ne sont pas rendues une par une : elles laissent place à
    // UNE ligne « pack », posée à l'emplacement de la première d'entre elles. Les autres
    // articles gardent leur index (`data-line`), donc /cart/change.js continue de viser juste.
    const packs = PACK ? PACK.groups(cartCache.items) : [];
    const groupByKey = new Map();
    packs.forEach((g) => g.keys.forEach((k) => groupByKey.set(k, g)));
    wrap.innerHTML = cartCache.items.map((item, idx) => {
      const group = groupByKey.get(item.key);
      if (group) {
        return item.key === group.firstKey ? PACK.rowHtml(group, PACK_CTX) : '';
      }
      const titleEsc = escapeHTML(item.product_title || '');
      const props = item.properties || {};
      const isGift    = props._is_gift   === 'true' || props._is_gift   === true;
      const isSample  = props._is_sample === 'true' || props._is_sample === true;
      const isFreebie = isGift || isSample;
      const isSub = props._subscription === '1' || props._subscription === 1;
      const subLabel = isSub ? (props['📦 Abonnement'] || props._subscription_frequency || 'Abonnement') : '';
      const subBadge = isSub
        ? `<span class="tlr-cart__item-sub" title="Abonnement OVRI"><span aria-hidden="true">🔁</span>${escapeHTML(subLabel)}</span>`
        : '';
      // Ligne offerte : pastille « offert » + valeur barrée de l'article. Le type (cadeau ou
      // échantillon) n'est pas écrit dans la pastille, il est porté par son libellé accessible.
      const freeType  = isGift ? (I18N.giftTypeGift || '') : (I18N.giftTypeSample || '');
      const freeValue = item.original_line_price || item.line_price || 0;
      const freeBadge = isFreebie
        ? `<span class="tlr-cart__item-gift">
             <span class="tlr-cart__item-badge is-gift" title="${escapeHTML(freeType)}" aria-label="${escapeHTML(freeType)}">${escapeHTML(I18N.giftFree || '')}</span>
             ${freeValue > 0 ? `<s class="tlr-cart__item-gift-was">${escapeHTML(fmtMoney(freeValue))}</s>` : ''}
           </span>`
        : '';
      // Prix barré / prix remisé sur l'item (UX subscription)
      // Cas 1 (Shopify discount actif) : line_price est DÉJÀ remisé, original_line_price = vrai original.
      // Cas 2 (preview) : line_price = original, on calcule le -15% visuel localement.
      let priceBlock;
      if (isSub) {
        let origPrice, finalPrice;
        if (shopifyDiscountActive) {
          origPrice = item.original_line_price || item.line_price || 0;
          finalPrice = item.final_line_price || item.line_price || origPrice;
          // Filet de sécurité : si Shopify n'a pas distribué le discount sur cette ligne
          if (finalPrice >= origPrice) {
            finalPrice = Math.round(origPrice * (100 - subDiscountPctItems) / 100);
          }
        } else {
          origPrice = item.line_price || item.final_line_price || 0;
          finalPrice = Math.round(origPrice * (100 - subDiscountPctItems) / 100);
        }
        priceBlock = `
          <div class="tlr-cart__item-price-stack">
            <s class="tlr-cart__item-price-orig">${fmtMoney(origPrice)}</s>
            <strong class="tlr-cart__item-price tlr-cart__item-price--sub">${fmtMoney(finalPrice)}</strong>
          </div>`;
      } else {
        const linePrice    = item.final_line_price || item.line_price || 0;
        // compare_at_price absent de cart.js → on lit le cache product.js
        const compareUnit  = item.compare_at_price
                          || compareCache[item.handle]?.[item.variant_id]
                          || 0;
        const compareTotal = compareUnit * (item.quantity || 1);
        const hasCompare   = compareTotal > linePrice;
        priceBlock = hasCompare
          ? `<div class="tlr-cart__item-price-stack">
               <s class="tlr-cart__item-price-orig">${fmtMoney(compareTotal)}</s>
               <strong class="tlr-cart__item-price tlr-cart__item-price--sale">${fmtMoney(linePrice)}</strong>
             </div>`
          : `<strong class="tlr-cart__item-price">${fmtMoney(linePrice)}</strong>`;
      }
      // Cadeaux/échantillons : ni prix ni quantité, la pastille et la valeur barrée portent
      // toute l'information — la rangée du bas n'est donc pas émise pour eux.
      if (isFreebie) priceBlock = '';
      const qtyBlock = isFreebie ? '' : `<div class="tlr-cart__item-qty">
              <button type="button" data-qty-action="decrease" aria-label="${escapeHTML(L('qtyDecrease'))}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-action="increase" aria-label="${escapeHTML(L('qtyIncrease'))}">+</button>
            </div>`;
      const bottomBlock = (qtyBlock || priceBlock)
        ? `<div class="tlr-cart__item-bottom">${qtyBlock}${priceBlock}</div>`
        : '';
      const closeSvg = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
      return `
      <article class="tlr-cart__item${isSub ? ' is-sub' : ''}${isFreebie ? ' is-freebie' : ''}" data-line="${idx + 1}" data-key="${escapeHTML(item.key || '')}">
        <img class="tlr-cart__item-img" src="${escapeHTML(item.image || '')}" alt="${titleEsc}" loading="lazy">
        <div class="tlr-cart__item-info">
          <div class="tlr-cart__item-top">
            <h4 class="tlr-cart__item-name">${escapeHTML(item.product_title || '')}</h4>
            <button type="button" class="tlr-cart__item-remove" data-qty-action="remove" aria-label="${escapeHTML(L('itemRemove'))}">${closeSvg}</button>
          </div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="tlr-cart__item-variant">${escapeHTML(item.variant_title)}</span>` : ''}
          ${subBadge}${freeBadge}
          ${bottomBlock}
        </div>
      </article>`;
    }).join('');
  }

  // Event delegation : un seul listener bound 1× sur le wrapper, survit aux rerenders
  let _itemsBound = false;
  function bindItemsDelegation() {
    if (_itemsBound) return;
    const wrap = $('[data-tlr-cart-items]');
    if (!wrap) return;
    wrap.addEventListener('click', async (e) => {
      // Ligne « pack » : le dépli n'est que de l'affichage, la croix retire tout le pack.
      const packToggle = e.target.closest('[data-pack-toggle]');
      if (packToggle && PACK) { PACK.toggle(packToggle); return; }
      const packRemove = e.target.closest('[data-pack-remove]');
      if (packRemove) {
        const row = packRemove.closest('[data-pack-group]');
        const keys = String(row?.dataset.keys || '').split(',').filter(Boolean);
        if (!keys.length) return;
        packRemove.disabled = true;
        (async () => {
          for (const key of keys) {
            try { await cartRemoveByKey(key); } catch (_) {}
          }
          await refreshCart();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-drawer' } }));
        })();
        return;
      }
      const btn = e.target.closest('[data-qty-action]');
      if (!btn) return;
      e.preventDefault();
      const item = btn.closest('[data-line]');
      if (!item) return;
      const line = parseInt(item.dataset.line, 10);
      const action = btn.dataset.qtyAction;
      // Récupère l'item via l'index (plus fiable que le key)
      const cartItem = cartCache?.items?.[line - 1];
      if (!cartItem) return;
      let newQty = cartItem.quantity;
      if (action === 'increase') newQty++;
      else if (action === 'decrease') newQty = Math.max(0, newQty - 1);
      else if (action === 'remove') newQty = 0;
      // Disable le bouton pendant la requête pour éviter double-click
      btn.disabled = true;
      try {
        const changed = await updateItem(line, newQty);
        // 0 is a removal, not a quantity.
        if (changed && newQty >= 1 && newQty <= 999) {
          window.tlr?.events?.publish?.('tlr_quantity', { product: String(cartItem.product_id), variant: String(cartItem.variant_id), qty: newQty });
        }
      } finally {
        btn.disabled = false;
      }
    });
    _itemsBound = true;
  }

  async function updateItem(line, quantity) {
    try {
      const r = await fetch(TLR_ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity }),
      });
      if (!r.ok) {
        console.warn('[tlr-cart] cart/change.js failed:', r.status, await r.text());
        // Re-fetch pour resync
        await refreshCart();
        return false;
      }
      cartCache = await r.json();
      render();
      // source:'cart-drawer' → le listener cart:updated skip le refreshCart() redondant
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-drawer' } }));
      return true;
    } catch (err) {
      console.warn('[tlr-cart] updateItem error:', err);
      await refreshCart();
      return false;
    }
  }

  function renderTotal() {
    const totalShopify      = cartCache.total_price || 0;
    const totalDiscountShop = cartCache.total_discount || 0;
    const shopifyCodeActive = totalDiscountShop > 0;          // Shopify a un code actif
    const ovriPct           = parseInt(window.tlr?.ovri?.discount_pct, 10) || 15;

    // Cherche les discounts dans discount_applications.
    // Inclut: 'discount_code' (codes promo) + 'automatic' (DiscountAutomatic) + 'script' (Shopify Scripts).
    const apps    = cartCache?.discount_applications || [];
    const codeApps = apps.filter(a => a.type === 'discount_code' || a.type === 'automatic' || a.type === 'script');
    const codeApp  = codeApps[0];
    const codeText = codeApp ? (codeApp.title || codeApp.key || '') : '';
    const codePct  = codeApp ? Math.round(parseFloat(codeApp.value || '0')) : 0;

    // Détecte si tous les codes appliqués sont nos codes freebie (TLRSAMPLE / TLRGIFT)
    // → masque la chip "code promo trompeuse" + label "🎁 Cadeaux offerts"
    // Comparaison exacte avec cart.discount_codes (le code lui-même, pas le human title)
    const appliedCodes = (cartCache?.discount_codes || [])
      .map(d => (d.code || '').toUpperCase())
      .filter(Boolean);
    const freebieCodesSet = new Set(
      [SAMPLE_CODE, GIFT_CODE].filter(Boolean).map(c => c.toUpperCase())
    );
    const allAreFreebies = appliedCodes.length > 0
      && appliedCodes.every(c => freebieCodesSet.has(c));

    let displayedTotal, discountAmount, discountPct, discountSource;

    if (shopifyCodeActive) {
      // Un code Shopify (TealerRun ou autre) est actif — on lit les valeurs réelles du cart
      displayedTotal = totalShopify;
      discountAmount = totalDiscountShop;
      // pct stable depuis le discount lui-même (codeApp.value) si dispo, sinon calcul ratio
      discountPct    = codePct || Math.round(totalDiscountShop / (totalShopify + totalDiscountShop) * 100);
      const isAutomatic = codeApp?.type === 'automatic';
      discountSource = allAreFreebies                       ? 'freebie'
                     : /^TRLRUN/i.test(codeText)            ? 'game'
                     : isAutomatic && codeText              ? 'automatic'  // bundle / promo auto
                     : codeText                             ? 'manual'
                     :                                        'shopify'; // discount actif mais code non exposé dans apps
    } else {
      // Pas de code Shopify → preview local OVRI abonnement
      let subItemsCents = 0;
      (cartCache.items || []).forEach((it) => {
        const p = it.properties || {};
        if (p._subscription === '1' || p._subscription === 1) {
          subItemsCents += it.line_price || it.final_line_price || 0;
        }
      });
      discountAmount = Math.round(subItemsCents * ovriPct / 100);
      displayedTotal = Math.max(0, totalShopify - discountAmount);
      discountPct    = ovriPct;
      discountSource = discountAmount > 0 ? 'ovri' : 'none';
    }

    $('[data-tlr-cart-total]').textContent = fmtMoney(displayedTotal);

    // Prix original barré = ce que le panier coûterait sans aucune remise : le total affiché,
    // plus les remises code/abonnement déjà déduites, plus les écarts compare_at_price des
    // lignes en promo. Une ligne offerte dont le code n'est pas encore appliqué est payée
    // plein tarif des deux côtés : elle ne crée aucun écart tant qu'elle n'est pas remisée.
    const originalEl = $('[data-tlr-cart-total-original]');
    if (originalEl) {
      const originalTotal = displayedTotal + discountAmount + computeCompareSavings();
      const hasDiscount = originalTotal > displayedTotal;
      originalEl.hidden = !hasDiscount;
      originalEl.textContent = hasDiscount ? fmtMoney(originalTotal) : '';
    }

    renderSubDiscountLines();
    renderTotalSavings();
  }

  /** Écart total compare_at_price vs prix payé, ligne par ligne (compare_at absent de cart.js). */
  function computeCompareSavings() {
    let savedCents = 0;
    (cartCache?.items || []).forEach(it => {
      const compareUnit  = it.compare_at_price || compareCache[it.handle]?.[it.variant_id] || 0;
      const compareTotal = compareUnit * (it.quantity || 1);
      const linePrice    = it.final_line_price || it.line_price || 0;
      if (compareTotal > linePrice) savedCents += compareTotal - linePrice;
    });
    return savedCents;
  }

  /** Bandeau "Tu économises X€" — somme de toutes les remises compare_at_price. */
  function renderTotalSavings() {
    const totalBlock = $('.tlr-cart__total');
    if (!totalBlock) return;
    let bar = $('[data-tlr-cart-savings]');

    const savedCents = computeCompareSavings();
    if (savedCents <= 0) { if (bar) bar.remove(); return; }

    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'tlr-cart__savings';
      bar.setAttribute('data-tlr-cart-savings', '');
      totalBlock.parentNode.insertBefore(bar, totalBlock);
    }
    bar.innerHTML = `
      <span class="tlr-cart__savings-label"><span aria-hidden="true">🎉</span> ${I18N.youSave || 'Tu économises'}</span>
      <strong class="tlr-cart__savings-value">${fmtMoney(savedCents)}</strong>`;
  }

  /** Supprime le code promo actif (vide le cookie discount Shopify). */
  async function removeDiscountCode() {
    try {
      // Pose un code vide → Shopify efface le discount de session
      const body = new URLSearchParams({ 'discount[code]': '', 'return_to': '/' });
      await fetch('/discount/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        credentials: 'same-origin',
        redirect: 'follow',
        body: body.toString(),
      });
    } catch (_) {}
    await refreshCart();
  }

  /** Affiche UNE ligne par code de réduction APPLIQUÉ (montant > 0 uniquement).
   *  - Freebies (TLRSAMPLE/TLRGIFT) : groupe en 1 ligne "🎁 Cadeaux offerts" (si sum > 0)
   *  - Autres codes (PACK5, BUNDLE15…) : 1 ligne par code avec son NOM (si amount > 0)
   *  - Fallback : si total_discount > 0 mais tous les codes affichent 0, montre 1 ligne globale. */
  function renderSubDiscountLines() {
    const totalBlock = $('.tlr-cart__total');
    if (!totalBlock) return;
    $$('[data-tlr-cart-sub-discount]').forEach(el => el.remove());

    const codes = cartCache?.discount_codes || [];
    const totalDiscount = cartCache?.total_discount || 0;

    // Helper. `label` peut contenir du HTML (chips déjà escapées en amont via prettyLabel).
    // Tous les autres params sont escape ici.
    function appendLine({ emoji, label, amountCents, showRemove, codeForRemove }) {
      const removeBtn = showRemove
        ? `<button type="button" class="tlr-cart__discount-chip-remove" data-tlr-remove-discount data-code="${escapeHTML(codeForRemove || '')}" aria-label="${escapeHTML(L('discountRemove'))}">×</button>`
        : '';
      const line = document.createElement('div');
      line.className = 'tlr-cart__sub-discount';
      line.setAttribute('data-tlr-cart-sub-discount', '');
      line.innerHTML = `
        <span class="tlr-cart__sub-discount-label">
          <span aria-hidden="true">${escapeHTML(emoji || '')}</span>
          ${label}
          ${removeBtn ? `<span class="tlr-cart__discount-chip-wrap">${removeBtn}</span>` : ''}
        </span>
        <strong class="tlr-cart__sub-discount-value">-${fmtMoney(amountCents)}</strong>
      `;
      totalBlock.parentNode.insertBefore(line, totalBlock);
      line.querySelector('[data-tlr-remove-discount]')?.addEventListener('click', async (e) => {
        const b = e.currentTarget;
        b.disabled = true;
        b.textContent = '…';
        await removeDiscountCode();
      });
    }

    if (totalDiscount <= 0) return;

    // Source de vérité : cart_level_discount_applications couvre TOUS les types
    // de promos appliquées au cart : codes (discount_code), discounts automatiques
    // (automatic), et discounts via Shopify Functions / Plus (discount_pack...).
    // → chacune a un `title` réel, jamais "code promo" générique.
    const apps = cartCache?.cart_level_discount_applications || [];

    // Pour les line-item level discounts (genre Pack Builder Function qui ajoute
    // un discount par ligne), on les agrège par title pour avoir un titre unique.
    const lineAppsMap = new Map(); // title → { title, amount, isCodeType }
    (cartCache?.items || []).forEach((it) => {
      (it.discounts || []).forEach((d) => {
        if (!d || !d.title) return;
        const prev = lineAppsMap.get(d.title) || { title: d.title, amount: 0, isCodeType: false };
        prev.amount += d.amount || 0;
        lineAppsMap.set(d.title, prev);
      });
    });

    // Fusionne : cart_level + line_level dédup par title (cart_level prime)
    const knownTitles = new Set(apps.map((a) => a.title));
    const allApps = [
      ...apps.map((a) => ({
        title: a.title || L('discountPromo'),
        amount: a.total_allocated_amount || 0,
        type: a.type || 'unknown', // 'discount_code' | 'automatic' | 'discount_pack' | ...
      })),
      ...[...lineAppsMap.values()]
        .filter((l) => !knownTitles.has(l.title))
        .map((l) => ({ title: l.title, amount: l.amount, type: 'line' })),
    ].filter((a) => (a.amount || 0) > 0);

    const freebieCodesSet = new Set([SAMPLE_CODE, GIFT_CODE].filter(Boolean).map((c) => c.toUpperCase()));
    const isFreebieTitle = (t) => freebieCodesSet.has((t || '').toUpperCase());

    const freebies = allApps.filter((a) => isFreebieTitle(a.title));
    const realApps = allApps.filter((a) => !isFreebieTitle(a.title));

    const freebieAmount = freebies.reduce((s, a) => s + (a.amount || 0), 0);

    // 1) Freebies (samples/gifts) → 1 ligne groupée "Cadeaux offerts"
    if (freebies.length > 0 && freebieAmount > 0) {
      appendLine({ emoji: '🎁', label: escapeHTML(L('discountGifts')), amountCents: freebieAmount, showRemove: false });
    }

    // Mapping noms publics : on cache les codes internes derrière des libellés
    // marketing pour éviter que les clients devinent les codes des bundles/jeux.
    // Les codes manuels (saisis par l'admin/client) restent affichés en raw.
    const prettyLabel = (rawCode) => {
      const c = (rawCode || '').toUpperCase();
      if (!c) return L('discountPromo');
      if (/^TLRFBT/i.test(c))    return L('discountPack');
      if (/^TLRPACK/i.test(c))   return L('discountPackBuilder');
      if (/^TRLRUN/i.test(c) || /^TEALERRUN/i.test(c)) return L('discountGame');
      if (/^TLRSAMPLE/i.test(c)) return L('giftTypeSample');
      if (/^TLRGIFT/i.test(c))   return L('giftTypeGift');
      if (/^TLRBUNDLE/i.test(c)) return L('discountBundle');
      // Codes auto Shopify (DiscountAutomaticBasic) : leur title est déjà humain
      // (ex: "Pack -15% bundle", "Offert"...) → on retourne tel quel.
      // Codes admin manuels (WELCOME10, NOEL2025...) : raw, le client le connait.
      return c;
    };

    // 2) Real promos → 1 ligne avec chips nominatives + total
    if (realApps.length > 0) {
      const realTotal = realApps.reduce((s, a) => s + (a.amount || 0), 0);
      if (realTotal > 0) {
        const chips = realApps
          .map((a) => `<strong class="tlr-cart__discount-code-name">${escapeHTML(prettyLabel(a.title))}</strong>`)
          .join(' ');
        // Bouton × pour retirer : uniquement si exactement 1 promo ET c'est un code (pas auto/line)
        const single = realApps.length === 1 ? realApps[0] : null;
        const isRemovableCode = single && single.type === 'discount_code';
        const singleTitle = single ? (single.title || '').toUpperCase() : '';
        appendLine({
          emoji: '🏷️',
          label: chips,
          amountCents: realTotal,
          showRemove: !!isRemovableCode,
          codeForRemove: singleTitle,
        });
      }
    }

    // 3) Résiduel : si totalDiscount > somme des apps, fallback générique
    //    (rare : peut arriver si Shopify n'a pas exposé toutes les sources)
    const apprAmount = freebieAmount + realApps.reduce((s, a) => s + (a.amount || 0), 0);
    const residual = totalDiscount - apprAmount;
    if (residual > 0 && allApps.length === 0) {
      appendLine({ emoji: '🏷️', label: escapeHTML(L('discountPromo')), amountCents: residual, showRemove: false });
    }
  }

  function renderLoyalty() {
    const total = cartCache.total_price || 0;
    const block = $('[data-tlr-cart-loyalty]');
    if (!block) return;
    if (total === 0) { block.hidden = true; return; }
    block.hidden = false;
    const loy = (window.tlrCartConfig && window.tlrCartConfig.loyalty) || {};
    const pts = Math.round(total / 100 * LOYALTY_POINTS_PER_EURO);
    const ptsEl = $('[data-tlr-loyalty-pts]');
    const rewardEl = $('[data-tlr-loyalty-reward]');
    const balanceEl = $('[data-tlr-loyalty-balance]');
    if (ptsEl) ptsEl.textContent = pts;
    if (rewardEl) {
      const reward = fmtMoney(Math.round(pts * LOYALTY_REWARD_PER_POINT * 100));
      rewardEl.textContent = reward;
    }
    if (balanceEl && loy.loggedIn) {
      const newBalance = (loy.balance || 0) + pts;
      balanceEl.textContent = newBalance;
    }
  }

  /** Cherche la ligne panier d'un cadeau (type='gift') ou échantillon (type='sample'). */
  function findGiftLine(type) {
    return (cartCache?.items || []).find(it => {
      const p = it.properties || {};
      if (type === 'gift')   return p._is_gift   === 'true' || p._is_gift   === true;
      if (type === 'sample') return p._is_sample === 'true' || p._is_sample === true;
      return false;
    }) || null;
  }
  /** Toutes les lignes gift (pour le multi-select au palier 4). */
  function findAllGiftLines() {
    return (cartCache?.items || []).filter(it => {
      const p = it.properties || {};
      return p._is_gift === 'true' || p._is_gift === true;
    });
  }
  /** Sync visuelle des boutons avec l'état panier (multi-select pour gifts). */
  function syncGiftButtons(grid, type) {
    if (!grid) return;
    const dataAttr = type === 'gift' ? 'data-gift-variant' : 'data-sample-variant';
    const dataKey  = type === 'gift' ? 'giftVariant'      : 'sampleVariant';
    if (type === 'gift') {
      const activeIds = new Set(findAllGiftLines().map(l => l.variant_id));
      grid.querySelectorAll(`[${dataAttr}]`).forEach(btn => {
        const id = parseInt(btn.dataset[dataKey], 10);
        btn.classList.toggle('is-selected', activeIds.has(id));
      });
    } else {
      const line = findGiftLine(type);
      const activeVId = line?.variant_id ?? null;
      grid.querySelectorAll(`[${dataAttr}]`).forEach(btn => {
        const id = parseInt(btn.dataset[dataKey], 10);
        btn.classList.toggle('is-selected', !!activeVId && id === activeVId);
      });
    }
  }
  /** Retire une ligne du panier par sa clé Shopify. */
  async function cartRemoveByKey(key) {
    const r = await fetch(TLR_ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    if (r.ok) cartCache = await r.json();
  }
  /**
   * Gère le clic sur un bouton cadeau/échantillon.
   * - sample (toujours single) : toggle on/off
   * - gift (multi-select avec max selon palier) :
   *   * déjà sélectionné → toggle off
   *   * max atteint → remove le plus ancien (FIFO) puis add
   *   * sinon → add
   */
  /** Apply un code promo silencieusement (cookie session Shopify, pas de navigation). */
  async function applyCode(code) {
    if (!code) return;
    try {
      const r = await fetch(`/discount/${encodeURIComponent(code)}`, { redirect: 'follow', credentials: 'same-origin' });
      if (!r.ok) console.warn('[tlr-cart] applyCode failed:', code, r.status);
    } catch (e) {
      console.warn('[tlr-cart] applyCode error:', code, e);
    }
  }

  async function handleGiftClick(variantId, type, grid, btn) {
    btn.disabled = true;
    btn.classList.add('is-loading');
    const vId = parseInt(variantId, 10);

    if (type === 'sample') {
      // Optimistic UI : marque le bouton sélectionné tout de suite
      const wasSelected = btn.classList.contains('is-selected');
      grid.querySelectorAll('.is-selected').forEach(b => b.classList.remove('is-selected'));
      if (!wasSelected) btn.classList.add('is-selected');

      // Anti-race : désactiver TOUS les boutons sample pendant l'opération
      const allSampleBtns = grid.querySelectorAll('[data-sample-variant]');
      allSampleBtns.forEach(b => { b.disabled = true; b.classList.add('is-loading'); });

      // Échantillon max 1 : récupérer TOUTES les lignes sample (pas juste la première)
      const allSampleLines = (cartCache?.items || []).filter(it => {
        const p = it.properties || {};
        return p._is_sample === 'true' || p._is_sample === true;
      });
      const isSameVariant = allSampleLines.length === 1 && allSampleLines[0].variant_id === vId;

      // Supprimer TOUTES les lignes sample existantes
      for (const line of allSampleLines) {
        try { await cartRemoveByKey(line.key); } catch (_) {}
      }
      // Ajouter le nouveau sample seulement si ce n'était pas un toggle-off
      if (!wasSelected || !isSameVariant) {
        try {
          await fetch(TLR_ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: vId, quantity: 1, properties: { _tlr: 'v2', _is_sample: 'true' } }] }),
          });
          // Aucun code à poser : les échantillons sont à 0 €, et depuis le Lot 45 la remise
          // des cadeaux est automatique. Le `/discount/` d'avant ne faisait qu'ajouter un
          // aller-retour réseau — et pouvait effacer un vrai code client.
        } catch (_) {}
      }
      await refreshCart();
      allSampleBtns.forEach(b => { b.disabled = false; b.classList.remove('is-loading'); });
      return;
    }

    // Les cadeaux passent par handleGiftPick : un choix par palier, pas un multi-select.
    btn.classList.remove('is-loading');
    btn.disabled = false;
  }

  /**
   * Clic sur un cadeau : le palier vient du bouton, jamais d'un compteur.
   *  - re-clic sur le cadeau déjà pris → on le retire (le palier redevient à choisir)
   *  - autre cadeau du même palier → échange en une seule opération, ajout d'abord
   *  - palier libre → ajout
   * Les mutations sont sérialisées (GIFTS.run) : deux clics rapides ne peuvent pas laisser
   * deux cadeaux sur un palier ni retirer celui qui vient d'être ajouté.
   */
  async function handleGiftPick(btn) {
    if (!GIFTS || !btn || btn.disabled) return;
    const variantId = parseInt(btn.dataset.giftVariant, 10);
    const tierKey = String(btn.dataset.giftTier || '');
    if (!variantId || !tierKey) return;

    const state = GIFTS.computeState(currentTiers(), cartCache?.items || [], computeRealPaidTotal());
    const row = state.rows.find((r) => r.tier.key === tierKey);
    if (!row || !row.reached) return;

    // UI optimiste : la sélection bascule tout de suite et revient si l'appel échoue.
    const wasSelected = btn.classList.contains('is-selected');
    const choices = btn.closest('.tlr-cart__gift-choices');
    if (choices) choices.querySelectorAll('.is-selected').forEach((b) => b.classList.remove('is-selected'));
    if (!wasSelected) btn.classList.add('is-selected');
    btn.classList.add('is-loading');
    btn.disabled = true;

    await GIFTS.run(async () => {
      try {
        if (row.line && row.line.variant_id === variantId) {
          await GIFTS.removeKey(row.line.key);
        } else if (row.line) {
          await GIFTS.swap(row.line.key, variantId, tierKey);
        } else {
          await GIFTS.add(variantId, tierKey);
        }
        giftNotice = '';
        editingTier = null;
      } catch (err) {
        btn.classList.toggle('is-selected', wasSelected);
        if (err && err.status === 422) {
          // Refus confirmé (rupture) : on barre le cadeau et le modèle s'en souvient — si le
          // palier n'a plus rien d'ajoutable, il passe la main au suivant au lieu d'enfermer
          // le client. Toute autre panne est passagère : on laisse le bouton cliquable.
          GIFTS.markUnavailable(variantId);
          btn.classList.add('is-unavailable');
          btn.disabled = true;
        }
        giftNotice = I18N.giftUnavailable || '';
      }
      await refreshCart();
      btn.classList.remove('is-loading');
    });
  }

  async function renderSamples() {
    const block = $('[data-tlr-cart-samples]');
    if (!block) return;
    const total    = computeRealPaidTotal();

    // Le bloc s'ouvre au premier palier qui donne quelque chose : l'échantillon (modèle
    // précédent), ou le premier palier récompense quand les paliers portent un type.
    if (PLAN.blockCents === null || total < PLAN.blockCents) { block.hidden = true; return; }
    block.hidden = false;

    // ── Col gauche : échantillons (charge 1× via lazy flag)
    const sampleCol  = $('[data-tlr-sample-section]');
    const sampleGrid = $('[data-tlr-samples-grid]');
    const sampleUnlocked = PLAN.sampleCents !== null && total >= PLAN.sampleCents;
    const sampleRewards = PLAN.sampleRewardsAt(total);
    // Aucun palier ne donne d'échantillon : la colonne n'a rien à proposer.
    if (sampleCol) sampleCol.hidden = !sampleUnlocked;
    if (sampleGrid) rearmRewardGrid(sampleGrid, sampleRewards);
    if (sampleUnlocked && sampleGrid && sampleGrid.dataset.loaded !== 'true') {
      sampleGrid.dataset.loaded = 'true';
      if (sampleRewards.length) {
        sampleGrid.innerHTML = rewardButtonsHtml(sampleRewards, 'sample');
      } else {
        const pending = sampleGrid.dataset.rewardKey;
        const samples = await Promise.all(
          SAMPLE_HANDLES.slice(0, 2).map(h =>
            fetch(`${TLR_ROOT}products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)
          )
        );
        // Catalogue changé pendant l'appel : un rendu plus récent a déjà repris la main.
        if (sampleGrid.dataset.rewardKey !== pending) return;
        sampleGrid.innerHTML = samples.filter(Boolean).map(s => `
          <button type="button" class="tlr-cart__sample-btn" data-sample-variant="${escapeHTML(String(s.variants[0].id))}" data-sample-handle="${escapeHTML(s.handle)}">
            ${s.featured_image ? `<img src="${escapeHTML(s.featured_image)}" alt="${escapeHTML(s.title || '')}" loading="lazy">` : ''}
            <span>${escapeHTML(shortRewardName(s.title))}</span>
          </button>`).join('');
      }
      sampleGrid.querySelectorAll('[data-sample-variant]').forEach(btn => {
        btn.addEventListener('click', () => handleGiftClick(btn.dataset.sampleVariant, 'sample', sampleGrid, btn));
      });
    }
    // Sync avec état panier à chaque render
    if (sampleGrid) syncGiftButtons(sampleGrid, 'sample');

    // ── Col droite : cadeaux, un palier à la fois ─────────────────────────
    renderGiftColumn(total);
  }

  /**
   * Colonne cadeau. Trois zones, dans cet ordre :
   *   1. les paliers déjà choisis, en récap compact (vignette, nom, « Changer »)
   *   2. le palier ouvert — celui qu'on change, sinon le plus bas atteint et libre — avec
   *      ses 1 ou 2 cadeaux
   *   3. à défaut, le prochain palier non atteint en aperçu, avec le montant restant
   *
   * Tout se redérive du panier : retirer un cadeau depuis la liste des articles rouvre son
   * palier au rendu suivant, sans que rien n'ait à s'en souvenir.
   */
  async function renderGiftColumn(total) {
    const section = $('[data-tlr-gift-section]');
    const grid = $('[data-tlr-gift-grid]');
    if (!section || !grid || !GIFTS) return;

    const tiers = await GIFTS.ensureTiers(TIERS, LEGACY_GIFTS);
    const state = GIFTS.computeState(tiers, cartCache?.items || [], total);
    section.hidden = !state.any;
    if (!state.any) return;
    bindGiftDelegation(section);

    // Un palier qu'on changeait mais qui n'a plus de cadeau (retiré ailleurs) n'est plus
    // « en changement » : il redevient un palier à choisir comme un autre.
    if (editingTier && !state.claimed.some((r) => r.tier.key === editingTier)) editingTier = null;

    const editingRow = editingTier ? state.rows.find((r) => r.tier.key === editingTier) : null;
    const openRow = editingRow || state.active;
    section.dataset.state = openRow || state.claimed.length ? 'unlocked' : 'locked';

    const label = section.querySelector('.tlr-cart__samples-col-eye');
    if (label) {
      const text = openRow
        ? GIFTS.fill(I18N.giftsTierPick || I18N.giftsPickOne || '', 'amount', fmtMoney(openRow.tier.cents))
        : GIFTS.headline(state, GIFT_CTX);
      label.textContent = decodeEntities(text || '');
    }

    const parts = [];
    if (giftNotice) parts.push(`<p class="tlr-cart__gift-note" role="status">${escapeHTML(giftNotice)}</p>`);
    parts.push(GIFTS.claimedHtml(state, GIFT_CTX));
    if (openRow) {
      const selected = editingRow && editingRow.line ? editingRow.line.variant_id : null;
      parts.push(
        `<div class="tlr-cart__samples-mini-grid tlr-cart__gift-choices" data-tlr-entry="gift">${GIFTS.gridHtml(openRow, GIFT_CTX, selected)}</div>`
      );
    } else if (state.next) {
      parts.push(GIFTS.lockedHtml(state.next, total, GIFT_CTX));
    }
    grid.className = 'tlr-cart__gift-body';
    grid.innerHTML = parts.filter(Boolean).join('');
    grid.dataset.loaded = 'true';
  }

  /** Un seul écouteur pour toute la colonne : la grille est reconstruite à chaque rendu. */
  function bindGiftDelegation(section) {
    if (section.dataset.tlrGiftBound === '1') return;
    section.dataset.tlrGiftBound = '1';
    section.addEventListener('click', (e) => {
      const edit = e.target.closest('[data-gift-edit]');
      if (edit) {
        editingTier = String(edit.dataset.giftEdit || '');
        giftNotice = '';
        renderGiftColumn(computeRealPaidTotal());
        return;
      }
      const pick = e.target.closest('[data-gift-variant]');
      if (pick) handleGiftPick(pick);
    });
  }

  async function renderUpsell() {
    const block = $('[data-tlr-cart-upsell]');
    if (!block) return;
    const list = $('[data-tlr-upsell-list]');
    if (!cartCache.items || cartCache.items.length === 0) { block.hidden = true; _upsellKey = null; return; }

    const cartHandles = cartCache.items.map(i => i.handle);
    let products = [];
    const customizerLocked = UPSELL_HANDLES.length > 0; // si customizer est utilisé, pas de fallback

    // Cache lazy : ne re-fetche les produits que si la source ou les articles cart ont changé
    // Clé = handles upsell (si customizer) OU product_id du 1er item + articles en cart
    const newUpsellKey = (customizerLocked ? UPSELL_HANDLES.join('|') : String(cartCache.items[0]?.product_id || ''))
                       + '::' + cartHandles.slice().sort().join('|');
    if (_upsellKey === newUpsellKey && list.children.length > 0) {
      // Freshness invariant (#129): whatever ordering or earlier fetch failure
      // produced this list, never keep proposing a product now in the cart.
      const stale = [...list.querySelectorAll('[data-upsell-handle]')]
        .some(el => cartHandles.includes(el.dataset.upsellHandle));
      if (!stale) { block.hidden = false; return; }
    }

    // 0. Customizer-picked products (priorité absolue, exclusive)
    if (customizerLocked) {
      const fetched = await Promise.all(
        UPSELL_HANDLES.map(h => fetch(`${TLR_ROOT}products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null))
      );
      products = fetched.filter(p => p && !cartHandles.includes(p.handle)).map(p => ({
        ...p,
        featured_image: p.featured_image || p.images?.[0],
        variant_id: p.variants?.[0]?.id,
      }));
    }

    // 1. Essaie /recommendations (UNIQUEMENT si customizer vide)
    if (!customizerLocked && cartCache.items[0]?.product_id) {
      try {
        const r = await fetch(`${TLR_ROOT}recommendations/products.json?product_id=${cartCache.items[0].product_id}&limit=${UPSELL_LIMIT}&intent=related`, { cache: 'no-store' });
        if (r.ok) {
          const d = await r.json();
          products = (d.products || []).filter(p => !cartHandles.includes(p.handle));
        }
      } catch (_) {}
    }

    // 2. Fallback collections (UNIQUEMENT si customizer vide)
    if (!customizerLocked && products.length < UPSELL_LIMIT) {
      const sources = ['best-sellers', 'fleurs-indoor', 'all'];
      for (const src of sources) {
        if (products.length >= UPSELL_LIMIT) break;
        try {
          const r = await fetch(`${TLR_ROOT}collections/${src}/products.json?limit=12&_t=${Date.now()}`, { cache: 'no-store' });
          if (!r.ok) continue;
          const d = await r.json();
          for (const p of (d.products || [])) {
            if (products.length >= UPSELL_LIMIT) break;
            if (cartHandles.includes(p.handle)) continue;
            if (products.find(x => x.handle === p.handle)) continue;
            products.push(p);
          }
        } catch (_) {}
      }
    }

    // A product with no sellable variant only renders a dead + (422): sold-out
    // picks leave the list — today BOTH customizer picks are out of stock, so
    // an empty hidden block is the honest render until the picks change.
    products = products.filter(p => (p.variants || []).some(v => v && v.available !== false) && !cartHandles.includes(p.handle));

    if (products.length === 0) {
      // Clear instead of just hiding: hidden children plus an already-updated
      // key let the next render resurrect a stale list through the early
      // return — the exact path that kept an in-cart product on display. The
      // key stays untouched so the next render simply retries the fetches.
      list.innerHTML = '';
      list.removeAttribute('data-tlr-entry');
      list.removeAttribute('data-tlr-products');
      block.hidden = true;
      return;
    }
    _upsellKey = newUpsellKey;
    block.hidden = false;
    const shown = products.slice(0, UPSELL_LIMIT);
    list.setAttribute('data-tlr-entry', 'drawer-upsell');
    list.setAttribute('data-tlr-products', shown.map(p => String(p.id ?? '')).filter(id => /^\d{1,20}$/.test(id)).slice(0, 20).join(','));
    list.innerHTML = shown.map(p => {
      // Shopify renvoie price soit en cents (number, ex: /products/{h}.js → 1990) soit en euros (string, ex: /collections/X/products.json → "19.90")
      // First sellable variant: an out-of-stock first variant made the + button
      // 422 silently. Feeds without an `available` field count as sellable.
      const v = (p.variants || []).find(x => x && x.available !== false) || p.variants?.[0];
      const rawPrice = v?.price ?? p.price ?? 0;
      const priceCents = (typeof rawPrice === 'number')
        ? rawPrice
        : Math.round(parseFloat(rawPrice) * 100);
      const img = p.featured_image?.url || p.featured_image || (p.images?.[0]?.src) || (p.images?.[0]) || '';
      const variantId = v?.id || p.variant_id;
      // The + adds this variant: its format (5g, 20 units) sits next to its price.
      const variantTitle = v?.title && v.title !== 'Default Title' ? v.title : '';
      const titleEsc = escapeHTML(p.title || '');
      return `
      <div class="tlr-cart__upsell-item" data-upsell-handle="${escapeHTML(p.handle || '')}">
        <img src="${escapeHTML(img)}" alt="${titleEsc}" loading="lazy">
        <div class="tlr-cart__upsell-info">
          <strong>${titleEsc}</strong>
          <span class="tlr-cart__upsell-price">${fmtMoney(priceCents)}${variantTitle ? `<span class="tlr-cart__upsell-variant">${escapeHTML(variantTitle)}</span>` : ''}</span>
        </div>
        <button type="button" class="tlr-cart__upsell-add" data-upsell-variant="${escapeHTML(String(variantId || ''))}" data-upsell-product="${escapeHTML(String(p.id || ''))}">+</button>
      </div>`;
    }).join('');

    list.querySelectorAll('[data-upsell-variant]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const id = btn.dataset.upsellVariant;
        if (!id) return;
        btn.disabled = true;
        btn.textContent = '...';
        try {
          const res = await fetch(TLR_ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1, properties: { _tlr: 'v2', _tlr_entry: window.tlr?.events?.entryFor?.(id, 'drawer-upsell') } }] }),
          });
          if (!res.ok) throw new Error('atc ' + res.status);
          window.tlr?.events?.added?.({ entry: 'drawer-upsell', variant: id, qty: 1, product: btn.dataset.upsellProduct });
          btn.textContent = '✓';
          await refreshCart();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(() => { btn.textContent = '+'; btn.disabled = false; }, 800);
        } catch (_) {
          btn.textContent = '✗';
          setTimeout(() => { btn.textContent = '+'; btn.disabled = false; }, 1200);
        }
      });
    });
  }

  $('[data-tlr-promo-toggle]')?.addEventListener('click', () => {
    const form = $('[data-tlr-promo-form]');
    form.hidden = !form.hidden;
    if (!form.hidden) form.querySelector('input').focus();
  });
  $('[data-tlr-promo-apply]')?.addEventListener('click', async () => {
    const code = $('[data-tlr-promo-input]').value.trim();
    if (!code) return;
    // Shopify n'accepte pas les codes via cart.js — on les append à l'URL checkout
    sessionStorage.setItem('tlrPromoCode', code);
    alert(L('promoSaved').replace('{code}', code));
  });

  $('[data-tlr-cart-checkout]')?.addEventListener('click', async () => {
    // Cadeau et échantillon sont déjà dans le panier (ajoutés au clic dans renderSamples)
    const code = sessionStorage.getItem('tlrPromoCode');
    let url = TLR_ROOT + 'checkout';
    if (code) url += '?discount=' + encodeURIComponent(code);
    window.location.href = url;
  });

  document.addEventListener('cart:updated', (e) => {
    // Si source='cart-drawer' : updateItem() a déjà mis à jour cartCache + appelé render()
    // → pas besoin d'un 2ème fetch /cart.js (évite le double round-trip sur delete/qty).
    // Pour les sources externes (PDP, quick-buy, apps), debounce 50ms pour coalescer
    // les rafales d'events (ex : app qui dispatche 3×cart:updated d'affilée).
    if (e?.detail?.source !== 'cart-drawer') {
      clearTimeout(_refreshDebounceTimer);
      _refreshDebounceTimer = setTimeout(refreshCart, 50);
    }
    // Si l'event vient de la page cart (mutation locale), on skip l'auto-open
    if (e?.detail?.silent === true || e?.detail?.source === 'cart-page') return;
    if (dlg.open) return; // déjà ouvert, on ne fait rien
    // Si animation fly en cours, attend 'tlr:fly:complete' pour ouvrir le drawer
    if (window._tlrFlyAnimating) {
      const onComplete = () => {
        document.removeEventListener('tlr:fly:complete', onComplete);
        setTimeout(() => { if (!dlg.open) window.tlrOpenCart(); }, 180);
      };
      document.addEventListener('tlr:fly:complete', onComplete);
      // Safety timeout
      setTimeout(() => {
        document.removeEventListener('tlr:fly:complete', onComplete);
        if (!dlg.open) window.tlrOpenCart();
      }, 1500);
    } else {
      setTimeout(() => { if (!dlg.open) window.tlrOpenCart(); }, 100);
    }
  });

  // Init. Lien d'un lot Tealer Run (envoyé par le hub, RUN-N23) : l'accueil arrive avec `?tlr_lot=1`, le lot déjà au
  // panier et son code posé. Le panier s'ouvre une fois (tlrOpenCart rafraîchit lui-même) ; le paramètre est retiré de
  // l'URL pour qu'un rechargement ou un partage du lien ne le rouvre pas.
  const lotUrl = new URL(window.location.href);
  if (lotUrl.searchParams.get('tlr_lot') === '1') {
    lotUrl.searchParams.delete('tlr_lot');
    history.replaceState(history.state, '', lotUrl.pathname + lotUrl.search + lotUrl.hash);
    window.tlrOpenCart();
  } else {
    refreshCart();
  }
})();

/* FORCE-PUSH 1778489267 — DO NOT REMOVE */
